import { FormType } from '../../../form-types';
import { ZaludUtiTreatmentQuestionFieldAnswers } from './questions';

const zaludUtiTreatment: FormType<ZaludUtiTreatmentQuestionFieldAnswers> = {
  name: 'UTI Treatment Intake',
  questions: [
    {
      key: 'zalud_uti_biologicalSex',
      next: {
        condition: { 'zalud_uti_biologicalSex.female': true },
        key: 'zalud_uti_redFlagSymptoms',
        els: 'zalud_uti_ineligible'
      }
    },
    {
      key: 'zalud_uti_redFlagSymptoms',
      next: {
        // Disqualify only on red-flag options (Notion). "I feel very ill" is not red.
        condition: {
          'zalud_uti_redFlagSymptoms.fever_chills': { $ne: true },
          'zalud_uti_redFlagSymptoms.flank_pain': { $ne: true },
          'zalud_uti_redFlagSymptoms.nausea_vomiting': { $ne: true },
          'zalud_uti_redFlagSymptoms.urinary_inability': { $ne: true }
        },
        key: 'zalud_uti_frequency',
        els: 'zalud_uti_ineligible'
      }
    },
    {
      key: 'zalud_uti_frequency',
      next: {
        condition: { 'zalud_uti_frequency.first_time_or_rarely': true },
        key: 'zalud_uti_urologicalConditions',
        els: 'zalud_uti_ineligible'
      }
    },
    {
      key: 'zalud_uti_urologicalConditions',
      next: {
        condition: { 'zalud_uti_urologicalConditions.none': true },
        key: 'zalud_uti_painBurning',
        els: 'zalud_uti_ineligible'
      }
    },
    'zalud_uti_painBurning',
    'zalud_uti_frequentUrination',
    'zalud_uti_urgency',
    'zalud_uti_lowerAbdominalPain',
    'zalud_uti_bloodInUrine',
    'zalud_uti_nocturia',
    'zalud_uti_symptomDuration',
    'zalud_uti_symptomIntensity',
    'zalud_uti_vaginalSymptoms',
    'zalud_uti_medicalConditions',
    'zalud_uti_antibioticAllergies',
    {
      key: 'zalud_uti_recentAntibiotics',
      next: {
        condition: { 'zalud_uti_recentAntibiotics.yes': true },
        key: 'zalud_uti_recentAntibioticsWhich',
        els: 'zalud_uti_negativeCulture'
      }
    },
    'zalud_uti_recentAntibioticsWhich',
    'zalud_uti_negativeCulture',
    'zalud_uti_additionalComments',
    {
      key: 'zalud_uti_consent',
      next: {
        condition: { 'zalud_uti_consent.proceed': true },
        key: 'zalud_uti_complete',
        els: 'zalud_uti_ineligible'
      }
    },
    'zalud_uti_complete',
    'zalud_uti_ineligible'
  ]
};

export default zaludUtiTreatment;
